import { Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OpdchartService } from 'src/app/private/services/opdchart.service';
import { TemplateService } from 'src/app/private/services/template.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import db from '../../../../../db/medicine_db.json';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { PrescriptionService } from 'src/app/utils/printService/prescription.service';
import moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { OcrService } from 'src/app/private/services/ocr.service';
import { OpdRefreshService } from 'src/app/private/services/opd-refresh.service';

@Component({
  selector: 'app-medications',
  templateUrl: './medications.component.html',
  styleUrls: ['./medications.component.scss']
})
export class MedicationsComponent implements OnDestroy {

  @Input() app_data:any
  @Input() patient:any
  @Input() titleOfHead: any = {
    title: 'OPD',
    root: 'Medications'
  };
  
  // Handwritten and OCR state
  activeModalTab: 'digital' | 'handwritten' = 'digital';
  handwrittenPrescriptionImage: string = '';
  ocrLoading: boolean = false;
  ocrResult: any = null;
  ocrMedications: any[] = [];
  ocrMedicationsText: string = '';
  todayDate: string = moment().format('DD-MM-YYYY');
  parsedAdvices: any = null;
  private _digitalDrugListSnapshot: any[] | null = null;
  headerImageBase64: string = '';
  footerImageBase64: string = '';
  enablePrintLayout: boolean = false;

  // Custom prescription configuration options
  prescriptionHeaderType: string = 'text1';
  prescriptionAccentColor: string = '#0d4259';
  enablePrescriptionLogo: boolean = false;
  prescriptionLogoBase64: string = '';
  enablePrescriptionWatermark: boolean = false;
  prescriptionWatermarkText: string = '';
  prescriptionWatermarkOpacity: number = 0.08;
  enablePrescriptionFooter: boolean = false;
  prescriptionFooterText: string = '';
  private _presc_doc_name: string = '';
  private _presc_doc_degree: string = '';

  get presc_doc_name(): string {
    const user = this.app_data?.appointment?.user;
    if (user) {
      const prefix = user.prefix || 'Dr';
      const fname = user.fname || '';
      const lname = user.lname || '';
      if (fname || lname) {
        return `${prefix}. ${fname} ${lname}`.trim();
      }
    }
    return this._presc_doc_name || window.localStorage.getItem('profile_name') || '';
  }

  set presc_doc_name(value: string) {
    this._presc_doc_name = value;
  }

  get presc_doc_degree(): string {
    const user = this.app_data?.appointment?.user;
    if (user && user.profile) {
      return user.profile;
    }
    return this._presc_doc_degree || '';
  }

  set presc_doc_degree(value: string) {
    this._presc_doc_degree = value;
  }

  presc_doc_reg: string = '';
  presc_clinic_name: string = '';
  presc_clinic_address: string = '';
  presc_clinic_phone: string = '';

  id:any;
  medicineDb:any = [];
  btnSaveLoading:boolean = false;
  saveToTemplate:boolean = false;
  medicationListData:any = []
  count:any = 0;
  drugList:any = [];
  tempDrugList:any = []
  templateDugList:any = [];
  templateName:any = ""
  templateSaveButton:boolean =false
  filteredMedicines:any = []
  tempMedicine:any = [];
  searchLoading = false;
  printButtonLoading:boolean = false;
  printPrescriptionObject:any;
  drugSearch = new Subject<string>();
  print_option:any = ['primary_checkups','medications'];
  diagnosisTemplateList:any = []
  currentTab:any;
  templateDiagnosis:any = [];
  loading:boolean = false;
  activeIndex: number[] = [];
  private _refreshSub?: Subscription;

  medicineArrayObject:any = {
    diagnosis:[],
  }

  medicineObject:any = {
    drug_type:"",
    drug_name:"",
    dosage:[]
  }
  layoutLoading:boolean = false;
  current_app_id:any;
  current_patient_id:any
  selectOrgan:any = "";
  tempName:any = "";
  temp_dosage: string[] = [];
  clearArray:boolean = false;
  showDiagnosisPopup:boolean = false;
  constructor(public route:ActivatedRoute,private opdChartAPI:OpdchartService, private toast:ToastrService, public dialog: MatDialog,private modalService: NgbModal,private api:TemplateService,private localStorage:LocalStorageService, private ocrService: OcrService, private printPrescriptionService: PrescriptionService, private opdRefreshService: OpdRefreshService)
  {
    this.route.params.subscribe(params =>
      {
        this.current_patient_id = params['id']
        this.current_app_id = params['app_id']
      })
   this.medicineDb = db;
    const isTrue = (key: string) => {
      const v = window.localStorage.getItem(key);
      return v === 'true' || v === '1' || v === 'yes';
    };

    this.enablePrintLayout = isTrue('enablePrintLayout');
    this.prescriptionHeaderType = window.localStorage.getItem('prescriptionHeaderType') || 'text1';
    this.prescriptionAccentColor = window.localStorage.getItem('prescriptionAccentColor') || '#0d4259';

    this.presc_doc_name = window.localStorage.getItem('presc_doc_name') || '';
    this.presc_doc_degree = window.localStorage.getItem('presc_doc_degree') || '';
    this.presc_doc_reg = window.localStorage.getItem('presc_doc_reg') || '';
    this.presc_clinic_name = window.localStorage.getItem('presc_clinic_name') || '';
    this.presc_clinic_address = window.localStorage.getItem('presc_clinic_address') || '';
    this.presc_clinic_phone = window.localStorage.getItem('presc_clinic_phone') || '';

    this.headerImageBase64 = window.localStorage.getItem('getBase64HeaderPrescription') || '';
    this.footerImageBase64 = window.localStorage.getItem('getBase64FooterPrescription') || '';

    this.enablePrescriptionLogo = isTrue('enablePrescriptionLogo');
    this.prescriptionLogoBase64 = window.localStorage.getItem('prescriptionLogoBase64') || '';

    this.enablePrescriptionWatermark = isTrue('enablePrescriptionWatermark');
    this.prescriptionWatermarkText = window.localStorage.getItem('prescriptionWatermarkText') || '';
    this.prescriptionWatermarkOpacity = parseFloat(window.localStorage.getItem('prescriptionWatermarkOpacity') || '0.08');

    this.enablePrescriptionFooter = isTrue('enablePrescriptionFooter');
    this.prescriptionFooterText = window.localStorage.getItem('prescriptionFooterText') || '';

    // Fallbacks if not set
    if (!this.presc_doc_name) this.presc_doc_name = window.localStorage.getItem('profile_name') || '';
    if (!this.presc_clinic_name) this.presc_clinic_name = window.localStorage.getItem('hospital_name') || '';
    if (!this.presc_clinic_address) this.presc_clinic_address = window.localStorage.getItem('hospital_address') || '';
    if (!this.presc_clinic_phone) this.presc_clinic_phone = window.localStorage.getItem('hospital_phone') || '';

  this.drugSearch.pipe(
    debounceTime(300)
).subscribe(value => {
  if(typeof value == "string")
  {
    //console.log(value.toLowerCase())
    this.filteredMedicines =  this.tempMedicine.filter(
      (item:any) => item.medicine_name.toLowerCase().includes(value.toLowerCase())
    )
  }
 

})

  }

 
  onDrawingChange(base64Image: string) {
    this.handwrittenPrescriptionImage = base64Image;
  }


  runPrescriptionOcr() {
    if (!this.handwrittenPrescriptionImage) {
      this.toast.warning('Please draw a prescription first.');
      return;
    }
    this.ocrLoading = true;
    this.ocrResult = null;
    this.ocrMedications = [];
    this.ocrMedicationsText = '';
    // Preserve any digital drugs already added so the merge can keep them
    this._digitalDrugListSnapshot = [...this.drugList];

    const rawBase64 = this.handwrittenPrescriptionImage.split(',')[1] || this.handwrittenPrescriptionImage;
    this.ocrService.recognizeHandwritten([rawBase64]).subscribe({
      next: (res) => {
        this.ocrLoading = false;
        if (res) {
          this.ocrResult = res;
          this.ocrMedications = res.medicines || [];
          this.formatOcrMedicationsToText();
          this.toast.success('Prescription OCR processed successfully!');
        } else {
          this.toast.error('Failed to extract data from prescription');
        }
      },
      error: (err) => {
        this.ocrLoading = false;
        console.error('OCR Error:', err);
        this.toast.error(err?.error?.message || 'Error occurred during OCR extraction');
      }
    });
  }

  formatOcrMedicationsToText() {
    let textLines: string[] = [];

    // 1. Vitals Section
    if (this.ocrResult && this.ocrResult.vitals && this.ocrResult.vitals.length > 0) {
      textLines.push('Vitals:');
      this.ocrResult.vitals.forEach((v: any) => {
        if (v.label && v.value) {
          textLines.push(`${v.label}: ${v.value}`);
        }
      });
      textLines.push('');
    }

    // 2. Rx Section
    textLines.push('Rx:');
    if (this.ocrMedications && this.ocrMedications.length > 0) {
      this.ocrMedications.forEach((med, index) => {
        let parts: string[] = [];
        let name = med.name || med.medicine_name || '';
        if (med.strength) name += ` ${med.strength}`;
        
        let line = `${index + 1}. `;
        if (med.form) {
          line += `${med.form} `;
        }
        line += name;

        if (med.dosage) parts.push(med.dosage);
        if (med.frequency) parts.push(med.frequency);
        if (med.timing) parts.push(med.timing);
        if (med.duration) parts.push(med.duration);
        if (med.notes) parts.push(med.notes);

        if (parts.length > 0) {
          line += ` - ${parts.filter(p => p.trim() !== '').join(' - ')}`;
        }
        textLines.push(line);
      });
    } else {
      textLines.push('1. ');
    }
    textLines.push('');

    // 3. Tests / Investigations Section
    if (this.ocrResult && this.ocrResult.tests && this.ocrResult.tests.length > 0) {
      textLines.push('Tests:');
      this.ocrResult.tests.forEach((t: any) => {
        const testName = typeof t === 'string' ? t : (t.name || t.investigation_name || '');
        if (testName) {
          textLines.push(`- ${testName}`);
        }
      });
      textLines.push('');
    }

    // 4. Advice Section
    if (this.ocrResult && this.ocrResult.advice && this.ocrResult.advice.length > 0) {
      textLines.push('Advice:');
      this.ocrResult.advice.forEach((a: any) => {
        const adviceText = typeof a === 'string' ? a : (a.text || a.advice || '');
        if (adviceText) {
          textLines.push(`- ${adviceText}`);
        }
      });
      textLines.push('');
    } else {
      textLines.push('Advice:');
      textLines.push('');
    }

    // 5. Follow Up Section
    if (this.ocrResult && this.ocrResult.follow_up) {
      textLines.push('Follow Up:');
      textLines.push(this.ocrResult.follow_up);
      textLines.push('');
    }

    this.ocrMedicationsText = textLines.join('\n').trim();
    this.parsePrescriptionText();
  }

  resetOcrText() {
    if (this.ocrResult) {
      // Snapshot current digital drugs so re-parse can merge without losing them
      this._digitalDrugListSnapshot = this.drugList.filter((d: any) => d.drug_type !== 'HANDWRITTEN_METADATA' && !this._isOcrDrug(d));
      this.ocrMedications = this.ocrResult.medicines || [];
      this.formatOcrMedicationsToText();
      this.toast.info('Reset to original AI extraction result.');
    }
  }

  private _isOcrDrug(drug: any): boolean {
    if (drug.source === 'ocr') return true;
    if (drug.drug_type === 'HANDWRITTEN_METADATA') return true;
    // Fallback for older database records
    return !drug.frequency && !drug.duration && (!drug.drug_name || !drug.drug_name.composition);
  }


  // ── Merge helpers ────────────────────────────────────────────────────────
  private getDrugKey(drug: any): string {
    const name = drug?.drug_name?.medicine_name || drug?.drug_name || '';
    return String(name).toLowerCase().trim();
  }

  private mergeDrugLists(existing: any[], incoming: any[]): any[] {
    const result = [...existing];
    const existingKeys = new Set(existing.map(d => this.getDrugKey(d)));
    for (const drug of incoming) {
      const key = this.getDrugKey(drug);
      if (key) {
        if (!existingKeys.has(key)) {
          result.push(drug);
          existingKeys.add(key);
        } else {
          // Update the dosage and drug_type of the existing drug with the incoming one
          const existingIndex = result.findIndex(d => this.getDrugKey(d) === key);
          if (existingIndex !== -1) {
            result[existingIndex] = {
              ...result[existingIndex],
              dosage: drug.dosage,
              drug_type: drug.drug_type || result[existingIndex].drug_type
            };
          }
        }
      }
    }
    return result;
  }
  // ─────────────────────────────────────────────────────────────────────────

  parsePrescriptionText() {
    // Keep any digital drugs that were already in the list (excluding any parsed OCR drugs)
    const digitalDrugs = this._digitalDrugListSnapshot ?? this.drugList.filter((d: any) => !this._isOcrDrug(d));
    const ocrOnlyDrugs: any[] = [];
    this.parsedAdvices = null;
    let parsedVitals: any = {};
    let parsedInvestigations: any[] = [];
    let advicesList: string[] = [];
    let followUpDate: string = '';

    if (!this.ocrMedicationsText) return;

    const lines = this.ocrMedicationsText.split('\n');
    let currentSection = 'rx'; // default to rx

    lines.forEach((line) => {
      const trimmed = line.trim();
      if (!trimmed) return;

      const lower = trimmed.toLowerCase();
      
      // Section headers check
      if (lower.startsWith('vitals:')) {
        currentSection = 'vitals';
        return;
      }
      if (lower.startsWith('rx:') || lower.startsWith('prescription:')) {
        currentSection = 'rx';
        return;
      }
      if (lower.startsWith('tests:') || lower.startsWith('investigations:')) {
        currentSection = 'tests';
        return;
      }
      if (lower.startsWith('advice:') || lower.startsWith('instructions:')) {
        currentSection = 'advice';
        return;
      }
      if (lower.startsWith('follow up:') || lower.startsWith('next visit:')) {
        currentSection = 'follow_up';
        return;
      }

      // Parse current section
      const isVitalLine = lower.startsWith('bp:') || 
                          lower.startsWith('blood pressure:') || 
                          lower.startsWith('temp:') || 
                          lower.startsWith('temperature:') || 
                          lower.startsWith('pulse:') || 
                          lower.startsWith('pulse rate:') || 
                          lower.startsWith('heart rate:') || 
                          lower.startsWith('pr:') || 
                          lower.startsWith('hr:') || 
                          lower.startsWith('weight:') || 
                          lower.startsWith('height:') || 
                          lower.startsWith('spo2:');

      if (currentSection === 'vitals' || isVitalLine) {
        const parts = trimmed.split(':').map(p => p.trim());
        if (parts.length >= 2) {
          const key = parts[0].toLowerCase().replace(/\s+/g, '_');
          const value = parts.slice(1).join(':');
          parsedVitals[key] = value;
        }
      } else if (currentSection === 'rx') {
        // Remove leading numbers
        const lineCleaned = trimmed.replace(/^\d+[\.\s\-)]+/, '').trim();
        if (!lineCleaned) return;

        // Smart parser to extract trailing dosage patterns (e.g. 1-0-1, 1-1-1, 1/2-0-1/2) even if no hyphens exist
        let dosageFromRegex = '';
        let lineForName = lineCleaned;
        const dosageMatch = lineCleaned.match(/\b\d+(?:[-/]\d+)+(?=\s*$)/);
        if (dosageMatch) {
          dosageFromRegex = dosageMatch[0];
          lineForName = lineCleaned.substring(0, dosageMatch.index).trim();
        }

        // Clean trailing spaces, hyphens, and commas
        lineForName = lineForName.replace(/[-,\s]+$/, '').trim();

        let delimiter = '-';
        if (!lineForName.includes('-') && lineForName.includes(',')) {
          delimiter = ',';
        }

        const parts = lineForName.split(delimiter).map(p => p.trim()).filter(Boolean);
        const fullMedicineName = parts[0] || lineForName;
        const nameLower = fullMedicineName.toLowerCase();

        let drugType = 'Others';
        if (nameLower.includes('tab') || nameLower.includes('tablet')) {
          drugType = 'TABLET';
        } else if (nameLower.includes('cap') || nameLower.includes('capsule')) {
          drugType = 'CAPSULE';
        } else if (nameLower.includes('drop')) {
          drugType = 'DROP';
        } else if (nameLower.includes('oint') || nameLower.includes('ointment') || nameLower.includes('cream')) {
          drugType = 'OINTMENT';
        } else if (nameLower.includes('syr') || nameLower.includes('syrup')) {
          drugType = 'SYRUP';
        } else if (nameLower.includes('inj') || nameLower.includes('injection')) {
          drugType = 'INJECTION';
        } else if (nameLower.includes('spray')) {
          drugType = 'SPRAY';
        } else if (nameLower.includes('lotion')) {
          drugType = 'LOTION';
        } else if (nameLower.includes('sachet')) {
          drugType = 'SACHETS';
        }

        let dosageArray: string[] = [];
        if (parts.length > 1) {
          dosageArray.push(...parts.slice(1));
        }
        if (dosageFromRegex) {
          dosageArray.push(dosageFromRegex);
        }
        if (dosageArray.length === 0) {
          dosageArray.push('As directed');
        }

        ocrOnlyDrugs.push({
          drug_type: drugType,
          drug_name: {
            medicine_name: fullMedicineName,
            composition: ''
          },
          dosage: dosageArray,
          source: 'ocr'
        });
      } else if (currentSection === 'tests') {
        const lineCleaned = trimmed.replace(/^[\-\*\d\.\s)]+/, '').trim();
        if (lineCleaned) {
          parsedInvestigations.push({
            investigation_name: lineCleaned
          });
        }
      } else if (currentSection === 'advice') {
        const lineCleaned = trimmed.replace(/^[\-\*\d\.\s)]+/, '').trim();
        if (lineCleaned) {
          advicesList.push(lineCleaned);
        }
      } else if (currentSection === 'follow_up') {
        followUpDate = trimmed.replace(/^[\-\*\d\.\s)]+/, '').trim();
      }
    });

    if (advicesList.length > 0 || followUpDate) {
      this.parsedAdvices = {
        advices: advicesList,
        nextVisit: followUpDate
      };
    }

    // Merge OCR-parsed drugs with digital drugs (digital wins on duplicate names)
    this.drugList = this.mergeDrugLists(digitalDrugs, ocrOnlyDrugs);
    // Clear snapshot after merge is applied
    this._digitalDrugListSnapshot = null;

    // Build a fully merged print object combining currentTab data with OCR sections
    const baseRecord = this.currentTab || {};
    this.printPrescriptionObject = {
      ...baseRecord,
      medications: this.drugList,
      primary_checkups: (Object.keys(parsedVitals).length > 0 ? parsedVitals : null) || baseRecord.primary_checkups || null,
      investigations: parsedInvestigations.length > 0 ? parsedInvestigations : (baseRecord.investigations || []),
      advices: this.parsedAdvices || baseRecord.advices || null,
      ophthalmic_examinations: baseRecord.ophthalmic_examinations || null
    };
  }

  printPrescriptionFromText() {
    this.parsePrescriptionText();
    if (this.drugList.length === 0) {
      this.toast.warning('No medications found to print.');
      return;
    }

    // printPrescriptionObject is already fully merged (digital + OCR + currentTab sections)
    // just ensure medications section is included in print options
    if (!this.print_option.includes('medications')) {
      this.print_option.push('medications');
    }

    this.printPrescription();
  }


  savePrescriptionFromText() {
    this.parsePrescriptionText();
    if (this.drugList.length === 0) {
      this.toast.warning('No medications found to save.');
      return;
    }

    this.saveMedication();
  }

  ngAfterViewInit()
  {
    this.getPatientMedicationData();
    this._refreshSub = this.opdRefreshService.prescriptionSaved$.subscribe(() => {
      this.getPatientMedicationData();
    });
  }

  ngOnDestroy() {
    this._refreshSub?.unsubscribe();
  }
addDiagnosis(item:any,organ:any,index:any)
{

  let existingArray = []
  let value:any = organ+" "+item
  this.tempName += item+",";
  this.templateName = this.removeLastComma(this.tempName);
  this.templateDiagnosis.push(item);
   existingArray = this.medicineArrayObject.diagnosis || [];
   this.medicineArrayObject.diagnosis = existingArray.concat(value);

   console.log( this.medicineArrayObject.diagnosis)
  //  this.showDiagnosisPopup = false;
   this.getDiagnosisMedicineTemplate();

   if(index!=-1){
     this.activeIndex.push(index)
   }
this.closeTemplate()
   console.log(this.activeIndex)

}



// addDiagnosisCheck(event:any, item:any,organ:any, index:any)
// {
//   console.log(event.target.checked)
//   if(event.target.checked){
//     console.log(true)
//     this.addDiagnosis(item,organ)
//     this.activeIndex.push(index)
//   }else{    
//     this.medicineArrayObject.diagnosis.splice(index, 1)
//     this.activeIndex.splice(index, 1)
//     console.log( this.medicineArrayObject.diagnosis)
//   }

// }

// removeTag(): void {
//   this.medicineArrayObject.diagnosis.splice(-1);
//   this.templateDiagnosis.splice(-1)
//   this.templateName = "";
//   this.templateDiagnosis.forEach((element:any) => {
//     this.tempName += element+",";
//   });
//   this.templateName = this.removeLastComma(this.tempName);
// }


removeLastComma(str:any) {
  return str.replace(/,\s*$/, "");
}
openDiagnosisTemplate()
{

  this.showDiagnosisPopup = true;
  this.getDiagnosisTemplate()
}
closeTemplate()
{
  this.showDiagnosisPopup = false;
}
selectOrganFn(event:any)
{
  this.selectOrgan = event.target.value;
}
onKeyUp(event: any): void {
  const inputValue: string = event.target.value;
  if (event.code === 'Backspace' && !inputValue) {
    this.removeTag(-1);
    return;
  } else {
    if (event.code === 'Comma' || event.code === 'Enter') {
      this.addDiagnosis(inputValue,"",-1);
      event.target.value = ""
    }
  }
}
removeTag(index:any): void {
  this.medicineArrayObject.diagnosis.splice(-1);
  this.templateDiagnosis.splice(-1)
  this.templateName = "";
  this.templateDiagnosis.forEach((element:any) => {
    this.tempName += element+",";
  });
  this.templateName = this.removeLastComma(this.tempName);

  if(index!=-1){
    this.activeIndex.splice(index, 1)
  }
}

  displayWith(value: any) {
    return value?.medicine_name;
  }

  OpenNewMedication(content:any)
  {
    this.getPatientMedicationData();
    this.getMedicationTemplate()
    this.modalService.open(content,  {  fullscreen: true, scrollable: false,ariaLabelledBy: 'modal-basic-title' });
  }
  clearData()
  {
    this.modalService.dismissAll();
    this.medicineObject = {
      drug_type:"",
      drug_name:"",
      dosage:[]
    }
    this.temp_dosage = [];
    this.saveToTemplate = false;
    this.activeModalTab = 'digital';
    this.handwrittenPrescriptionImage = '';
    this.ocrResult = null;
    this.ocrMedications = [];
    this.ocrMedicationsText = '';
  }
  fnOnDrugSearch(event:any)
  {
    this.drugSearch.next(event);
  }
  copyTemplate(item:any)
  {
    this.drugList =  [...this.drugList , ...item.data] ;
  
  }
  addDrug()
  {

  if(this.medicineObject.drug_type=="")
  {
   this.toast.error("Select Drug Type")
  }
  else if(this.medicineObject.drug_name=="")
  {
   this.toast.error("Select Drug Name")
  }
  else
  {
    console.log(this.medicineObject.drug_name)
    if(typeof this.medicineObject.drug_name == 'string'){
      this.medicineObject.drug_name = {medicine_name: this.medicineObject.drug_name,composition: ""}}

      if(this.medicineObject.drug_type==="CAPSULE" || this.medicineObject.drug_type==="TABLET" || this.medicineObject.drug_type==="INJECTION")
      {

      // let repetition = (this.medicineObject.frequency.match(/1/g) || []).length;
      // let days = this.countOccurrences(this.medicineObject.duration)
      // let qty = repetition * days * this.medicineObject.duration_count;
      // this.medicineObject.quantity = qty;
      }
  

      console.log(this.medicineObject)
      console.log(this.temp_dosage)
     this.medicineObject.dosage = this.temp_dosage;
     console.log("medd : ",this.medicineObject);

    this.drugList.push(this.medicineObject)

    this.medicineObject = {
     drug_type:this.medicineObject.drug_type,
     drug_name:"",
     dosage:[]
   }
   this.temp_dosage = [];
   this.clearArray = true;
    setTimeout(() => {
      this.clearArray = false;
    }, 100);

   //this.temp_dosage = [];
  }

  }

  selectDrugType(type: string) {
    this.medicineObject.drug_type = type;
    const mockEvent = { target: { value: type } };
    this.FilterByDrugType(mockEvent);
    
    // Auto focus the Search Drug Name input element
    setTimeout(() => {
      const el = document.querySelector('input[placeholder="Search Drug Name"]') as HTMLInputElement;
      if (el) el.focus();
    }, 80);
  }

  addQuickDosage(value: string) {
    if (!this.temp_dosage) {
      this.temp_dosage = [];
    }
    if (!this.temp_dosage.includes(value)) {
      this.temp_dosage = [...this.temp_dosage, value];
    }
  }

   countOccurrences(str:any) {
    let count = 0;
    if(str === "day(s)"){
      count = 1
    }
    else if(str === "weeks(s)"){
      count = 7
    }
    else if(str === "month(s)"){
      count = moment().daysInMonth()
    }
    return count;
  }
  FilterByDrugType(obj:any)
{
  let value = obj.target.value;
  this.filteredMedicines = [];
  this.filteredMedicines = this.medicineDb.filter(
    (item:any) => item.medicine_name.toLowerCase().match(value.toLowerCase())
  );
  this.tempMedicine = [];
  this.tempMedicine =  this.filteredMedicines;
 
}

  removeDrug(i:any)
  {
    this.drugList.splice(i, 1)
    
  }
  saveMedication()
  {
    if (this.activeModalTab === 'handwritten') {
      this.parsePrescriptionText();
    }
    // Append drawing pad canvas and OCR state block into the medications array to guarantee persistence
    const medicationsToSave = [...this.drugList];
    if (this.handwrittenPrescriptionImage || this.ocrResult) {
      medicationsToSave.push({
        drug_type: 'HANDWRITTEN_METADATA',
        handwritten_prescription: this.handwrittenPrescriptionImage,
        processed_prescription: this.ocrResult ? JSON.stringify(this.ocrResult) : null
      });
    }

    // Sync printPrescriptionObject so the inline preview reflects the latest merged state
    const baseRecord = this.currentTab || {};
    const existingPrint = this.printPrescriptionObject || {};
    this.printPrescriptionObject = {
      ...baseRecord,
      medications: this.drugList,
      primary_checkups: existingPrint.primary_checkups || baseRecord.primary_checkups || null,
      investigations: (existingPrint.investigations?.length ? existingPrint.investigations : null) || baseRecord.investigations || [],
      advices: this.parsedAdvices || existingPrint.advices || baseRecord.advices || null,
      ophthalmic_examinations: existingPrint.ophthalmic_examinations || baseRecord.ophthalmic_examinations || null
    };

    if(this.id)
    {
     this.btnSaveLoading = true;
     let param = {
       hospital_id:this.localStorage.getHospitalId(),
       center_id:this.localStorage.getCenterId(),
       id:this.id,
       medications:medicationsToSave,
       diagnosis:this.medicineArrayObject.diagnosis,
       handwritten_prescription:this.handwrittenPrescriptionImage || undefined,
       processed_prescription:this.ocrResult ? JSON.stringify(this.ocrResult) : undefined,
       primary_checkups: this.printPrescriptionObject.primary_checkups || undefined,
       investigations: (this.printPrescriptionObject.investigations && this.printPrescriptionObject.investigations.length > 0) ? this.printPrescriptionObject.investigations : undefined,
       ophthalmic_examinations: this.printPrescriptionObject.ophthalmic_examinations || undefined,
       advices: this.printPrescriptionObject.advices || undefined
       }
 
 
      this.opdChartAPI.updateOpdChartData(param).subscribe({
       next:(res)=>{
         if(res)
         {
           this.btnSaveLoading = false;
           this.toast.success("Data Saved successfully...")
           this.getPatientMedicationData();
           // Notify Prescriptions tab to refresh
           this.opdRefreshService.notifyPrescriptionSaved(this.current_patient_id);
           if(this.saveToTemplate)
           {
            this.SaveMedicationTemplate();
           }
        
          this.clearData()
         }
       },error:(e)=>{
         this.btnSaveLoading = false;
       }
      })
    }
    else{
      this.btnSaveLoading = true;
     let param = {
       hospital_id:this.localStorage.getHospitalId(),
       center_id:this.localStorage.getCenterId(),
       patient_id:this.app_data.id,
       app_id:this.app_data.appointment.app_id,
       medications:medicationsToSave,
       diagnosis:this.medicineArrayObject.diagnosis,
       handwritten_prescription:this.handwrittenPrescriptionImage || undefined,
       processed_prescription:this.ocrResult ? JSON.stringify(this.ocrResult) : undefined,
       primary_checkups: this.printPrescriptionObject.primary_checkups || undefined,
       investigations: (this.printPrescriptionObject.investigations && this.printPrescriptionObject.investigations.length > 0) ? this.printPrescriptionObject.investigations : undefined,
       ophthalmic_examinations: this.printPrescriptionObject.ophthalmic_examinations || undefined,
       advices: this.printPrescriptionObject.advices || undefined
       }
       
   
      this.opdChartAPI.createOpdChartData(param).subscribe({
       next:(res)=>{
         if(res)
         {
           this.btnSaveLoading = false;
           this.toast.success("Data Saved successfully...")
           this.clearData()
           this.getPatientMedicationData();
           // Notify Prescriptions tab to refresh
           this.opdRefreshService.notifyPrescriptionSaved(this.current_patient_id);
           this.SaveMedicationTemplate();
         
         }
       },error:(e)=>{
         this.btnSaveLoading = false;
       }
      })
    }
   
  }
  getMedicationTemplate()
  {
    let param = {
      where:{
      specialty: this.localStorage.getSpecialty(),
      }
    }
    this.opdChartAPI.getMedicationTemplate(param).subscribe({
      next:(res)=>{
        if(res)
        {
          this.templateDugList = res;
        }
      },
      error:(e)=>{

      }
     })
  }
  SaveMedicationTemplate()
  {
     if(this.templateName)
     {
      let param = {
        title:this.templateName,
        data:this.drugList,
        diagnosis:this.templateDiagnosis,
        hospital_id:this.localStorage.getHospitalId(),
        specialty: this.localStorage.getSpecialty(),
      }
      this.templateSaveButton = true;
         this.opdChartAPI.createMedicationTemplate(param).subscribe({
          next:(res)=>{
            if(res)
            {
              //this.toast.success("Template Added Successfully")
              this.templateSaveButton = false;
              //this.  getMedicationTemplate()
            }
          },
          error:(e)=>{
            this.templateSaveButton = false;
          }
         })
     }
     else
     {
      //this.toast.error("Template should not blank")
     }

  }

  getDiagnosisTemplate()
  {

    let param = {
      where:{
        specialty:this.localStorage.getSpecialty()
      }
    }
    this.api.getDiagnosisTemplate(param).subscribe({
      next:(res)=>{
        if(res)
        {
          this.diagnosisTemplateList = res;
        }
      },
      error:(e)=>{

      }
    })
  }

  getPatientMedicationData()
  {
  // console.log(this.app_data)
  this.loading = true;
    let param = {
      where:{
     hospital_id:this.localStorage.getHospitalId(),
      center_id:this.localStorage.getCenterId(),
      patient_id:this.current_patient_id,
      },
      attributes:['id','app_id','hospital_id','patient_id','center_id','medications','diagnosis','primary_checkups','investigations','ophthalmic_examinations','advices','createdAt']
    }
   this.opdChartAPI.getAllOpdChartData(param).subscribe({
     next:(res)=>{
      if(res)
      {
        this.count = res.filter((item:any)=>{
          if (item.medications) {
            return item.medications.filter((m: any) => m.drug_type !== 'HANDWRITTEN_METADATA').length > 0;
          }
          return false;
        }).length;
    
     
        this.medicationListData = res.filter((item:any)=>{return item.app_id != this.app_data.appointment.app_id && item.medications }).map((item: any) => {
          const metaItem = item.medications.find((m: any) => m.drug_type === 'HANDWRITTEN_METADATA');
          return {
            ...item,
            handwritten_prescription: metaItem ? metaItem.handwritten_prescription : (item.handwritten_prescription || ''),
            medications: item.medications.filter((m: any) => m.drug_type !== 'HANDWRITTEN_METADATA')
          };
        });

        let existingObject  = res.filter((item:any)=>{return item.app_id == this.app_data.appointment.app_id })[0]
        if(existingObject!=undefined)
        {
          this.id =  existingObject.id || undefined;
          this.medicineArrayObject.diagnosis = existingObject.diagnosis || [] 
          this.currentTab = existingObject;
          
          if(existingObject.medications){
            // Extract handwritten metadata if present
            let metaItem = existingObject.medications.find((m:any) => m.drug_type === 'HANDWRITTEN_METADATA');
            if (metaItem) {
              this.handwrittenPrescriptionImage = metaItem.handwritten_prescription || '';
              this.ocrResult = metaItem.processed_prescription ? JSON.parse(metaItem.processed_prescription) : null;
              if (this.ocrResult) {
                this.ocrMedications = this.ocrResult.medicines || (this.ocrResult.data && this.ocrResult.data.medications) || [];
                this.formatOcrMedicationsToText();
              }
            } else {
              this.handwrittenPrescriptionImage = existingObject.handwritten_prescription || '';
              this.ocrResult = existingObject.processed_prescription ? JSON.parse(existingObject.processed_prescription) : null;
              if (this.ocrResult) {
                this.ocrMedications = this.ocrResult.medicines || (this.ocrResult.data && this.ocrResult.data.medications) || [];
                this.formatOcrMedicationsToText();
              }
            }

            // Clean medications array from metadata items
            this.drugList = existingObject.medications.filter((m:any) => m.drug_type !== 'HANDWRITTEN_METADATA');
            this.currentTab = {
              ...existingObject,
              medications: this.drugList
            };
          }

          // Dynamic print_option initialization
          // Build a merged prescription object: take the most-recent non-null
          // value for each section across ALL records for this patient.
          // This ensures sections saved in other visits (primary_checkup,
          // ophthalmic_examinations etc.) still show in Include checkboxes.
          const latestFor = (key: string) => {
            for (const r of res) {
              const v = r[key];
              if (key === 'investigations' && Array.isArray(v) && v.length > 0) return v;
              if (key === 'medications') continue; // handled separately
              if (v && typeof v === 'object' && Object.values(v).some((x: any) => x !== null && x !== '')) return v;
            }
            return null;
          };

          const existingPrint = this.printPrescriptionObject || {};
          this.printPrescriptionObject = {
            ...(this.currentTab || {}),
            primary_checkups:       this.currentTab?.primary_checkups       || existingPrint.primary_checkups || latestFor('primary_checkups'),
            investigations:         (this.currentTab?.investigations?.length ? this.currentTab.investigations : null) || (existingPrint.investigations?.length ? existingPrint.investigations : null) || latestFor('investigations') || [],
            ophthalmic_examinations:this.currentTab?.ophthalmic_examinations || existingPrint.ophthalmic_examinations || latestFor('ophthalmic_examinations'),
            advices:                this.currentTab?.advices                 || existingPrint.advices || latestFor('advices'),
            medications:            this.drugList,
          };

          this.print_option = ['medications'];
          const keysToCheck = [
            { key: 'primary_checkups', val: 'primary_checkups' },
            { key: 'investigations', val: 'investigations' },
            { key: 'auto_refraction', val: 'auto_refraction' },
            { key: 'vision_acuity', val: 'vision_acuity' },
            { key: 'refraction', val: 'refraction' },
            { key: 'anterior_segment', val: 'anterior_segment' },
            { key: 'fundus_examination', val: 'fundus_examination' },
            { key: 'iop', val: 'iop' },
            { key: 'advices', val: 'advices' }
          ];
          keysToCheck.forEach(opt => {
            if (this.hasSectionData(opt.key) && !this.print_option.includes(opt.val)) {
              this.print_option.push(opt.val);
            }
          });

        }

        this.loading = false;
        this.layoutLoading = true;
      
      }
  
     },
     error:(e)=>{
      this.loading = false;
     }
   })
  }
  getDiagnosisMedicineTemplate()
  {
    let param = {
      hospital_id:this.localStorage.getHospitalId(),
      diagnosis:this.templateDiagnosis
    }
    this.api.getMedicinesDiagnosisTemplate(param).subscribe({
      next:(res) =>
      {
        if(res && res.data)
        {
          // Merge template drugs — do not replace existing digital/OCR entries
          this.drugList = this.mergeDrugLists(this.drugList, res.data);
        }
      }
    })
  }
  hasData(key: string): boolean {
    if (!this.printPrescriptionObject) return false;
    const obj = this.printPrescriptionObject;
    
    if (key === 'primary_checkups') {
      return obj.primary_checkups && Object.values(obj.primary_checkups).some(val => val !== null && val !== '');
    }
    
    if (key === 'investigations') {
      return obj.investigations && obj.investigations.length > 0;
    }
    
    if (key === 'medications') {
      return obj.medications && obj.medications.filter((m: any) => m.drug_type !== 'HANDWRITTEN_METADATA').length > 0;
    }
    
    if (key === 'advices') {
      return obj.advices && ((obj.advices.advices && obj.advices.advices.length > 0) || obj.advices.nextVisit);
    }
    
    const eyeExam = obj.ophthalmic_examinations;
    if (!eyeExam) return false;

    if (key === 'auto_refraction') {
      return this.hasObjectData(eyeExam.auto_refraction);
    }
    if (key === 'vision_acuity') {
      return this.hasObjectData(eyeExam.vision_acuity);
    }
    if (key === 'refraction') {
      return this.hasObjectData(eyeExam.refraction);
    }
    if (key === 'anterior_segment') {
      return this.hasObjectData(eyeExam.anterior_segment);
    }
    if (key === 'fundus_examination') {
      return this.hasObjectData(eyeExam.fundus_examination);
    }
    if (key === 'iop') {
      return this.hasObjectData(eyeExam.iop);
    }

    return false;
  }

  hasObjectData(subObj: any): boolean {
    if (!subObj) return false;
    if (typeof subObj !== 'object') {
      return subObj !== null && subObj !== '';
    }
    return Object.values(subObj).some(val => this.hasObjectData(val));
  }

  editMedication(content:any,item:any)
  {
    this.getPatientMedicationData();
    this.getMedicationTemplate()
    this.modalService.open(content,  {  fullscreen: true, centered:true, scrollable: false,ariaLabelledBy: 'modal-basic-title' });
    this.drugList = item; 
  }
  createPrescription(prescription:any,item:any)
  {
    // Merge the passed item with the already-merged printPrescriptionObject
    // so all sections (primary_checkups, ophthalmic etc.) remain visible
    // even if the selected item only has medications.
    const base = this.printPrescriptionObject || {};
    this.printPrescriptionObject = {
      ...base,
      ...item,
      // Preserve sections from base if item doesn't have them
      primary_checkups:        item.primary_checkups        || base.primary_checkups        || null,
      investigations:          (item.investigations?.length  ? item.investigations  : null)  || base.investigations  || [],
      ophthalmic_examinations: item.ophthalmic_examinations  || base.ophthalmic_examinations  || null,
      advices:                 item.advices                  || base.advices                  || null,
      medications:             item.medications              || base.medications              || this.drugList,
    };
    // Filter default print options to only include sections with actual data
    this.print_option = [];
    const keysToCheck = [
      { key: 'primary_checkups', val: 'primary_checkups' },
      { key: 'investigations', val: 'investigations' },
      { key: 'auto_refraction', val: 'auto_refraction' },
      { key: 'vision_acuity', val: 'vision_acuity' },
      { key: 'refraction', val: 'refraction' },
      { key: 'anterior_segment', val: 'anterior_segment' },
      { key: 'fundus_examination', val: 'fundus_examination' },
      { key: 'iop', val: 'iop' },
      { key: 'advices', val: 'advices' },
      { key: 'medications', val: 'medications' }
    ];
    keysToCheck.forEach(opt => {
      if (this.hasData(opt.key)) {
        this.print_option.push(opt.val);
      }
    });

    this.modalService.open(prescription,  {  size:'lg', scrollable: false,ariaLabelledBy: 'modal-basic-title' });
  }

  addPrintOption(event:any){
    if(event.target.checked){
      this.print_option.push(event.target.value)
    }
    else{
      this.print_option = this.print_option.filter((item:any)=> item != event.target.value)
    }
  }
  printPrescription(){
   // console.log(this.print_option)
    let param = {
      print_option:this.print_option,
      patientInfo:this.app_data,
      patient_id:this.current_patient_id,
      pId:this.app_data?.pId,
      app_id:this.current_app_id,
      prescription:this.printPrescriptionObject,
    }
  //  console.log(param)
    this.printPrescriptionService.generatePdf(param, 'print');
  }

  getDosageValue(data:any)
  {
   console.log(data)
   this.temp_dosage = data;
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }

  togglePrintOption(option: string) {
    if (this.print_option.includes(option)) {
      this.print_option = this.print_option.filter((o: any) => o !== option);
    } else {
      this.print_option.push(option);
    }
  }

  hasOphthalmicOption(): boolean {
    const options = ['auto_refraction', 'vision_acuity', 'refraction', 'anterior_segment', 'fundus_examination', 'iop'];
    return options.some(opt => this.print_option.includes(opt));
  }

  toggleOphthalmicOptions(event: any) {
    const checked = event.target.checked;
    const options = ['auto_refraction', 'vision_acuity', 'refraction', 'anterior_segment', 'fundus_examination', 'iop'];
    if (checked) {
      options.forEach(opt => {
        if (!this.print_option.includes(opt)) {
          this.print_option.push(opt);
        }
      });
    } else {
      this.print_option = this.print_option.filter((opt: any) => !options.includes(opt));
    }
  }

  hasSectionData(key: string): boolean {
    if (this.printPrescriptionObject && this.hasData(key)) {
      return true;
    }
    if (this.currentTab) {
      const obj = this.currentTab;
      if (key === 'primary_checkups') {
        return obj.primary_checkups && Object.values(obj.primary_checkups).some(val => val !== null && val !== '');
      }
      if (key === 'investigations') {
        return obj.investigations && obj.investigations.length > 0;
      }
      if (key === 'medications') {
        return obj.medications && obj.medications.filter((m: any) => m.drug_type !== 'HANDWRITTEN_METADATA').length > 0;
      }
      if (key === 'advices') {
        return obj.advices && ((obj.advices.advices && obj.advices.advices.length > 0) || obj.advices.nextVisit);
      }
      
      const eyeExam = obj.ophthalmic_examinations;
      if (eyeExam) {
        if (key === 'auto_refraction') return this.hasObjectData(eyeExam.auto_refraction);
        if (key === 'vision_acuity') return this.hasObjectData(eyeExam.vision_acuity);
        if (key === 'refraction') return this.hasObjectData(eyeExam.refraction);
        if (key === 'anterior_segment') return this.hasObjectData(eyeExam.anterior_segment);
        if (key === 'fundus_examination') return this.hasObjectData(eyeExam.fundus_examination);
        if (key === 'iop') return this.hasObjectData(eyeExam.iop);
      }
    }
    return false;
  }

  hasAnyOphthalmicOption(): boolean {
    return this.hasSectionData('auto_refraction') ||
           this.hasSectionData('vision_acuity') ||
           this.hasSectionData('refraction') ||
           this.hasSectionData('anterior_segment') ||
           this.hasSectionData('fundus_examination') ||
           this.hasSectionData('iop');
  }

  getVitalsString(): string {
    let vitals = null;
    if (this.printPrescriptionObject && this.printPrescriptionObject.primary_checkups) {
      vitals = this.printPrescriptionObject.primary_checkups;
    } else if (this.currentTab && this.currentTab.primary_checkups) {
      vitals = this.currentTab.primary_checkups;
    }
    if (!vitals) return '';
    return Object.entries(vitals)
      .filter(([key, val]) => {
        if (['id', 'patient_id', 'app_id', 'hospital_id', 'center_id', 'createdAt', 'updatedAt'].includes(key)) return false;
        if (val === null || val === undefined || val === '') return false;
        if (Array.isArray(val) && val.length === 0) return false;
        return true;
      })
      .map(([key, val]) => {
        const name = key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
        const valueStr = Array.isArray(val) ? val.join(', ') : String(val);
        return `${name}: ${valueStr}`;
      })
      .join(' | ');
  }

  getInvestigationsList(): string[] {
    let investigations = [];
    if (this.printPrescriptionObject && this.printPrescriptionObject.investigations && this.printPrescriptionObject.investigations.length > 0) {
      investigations = this.printPrescriptionObject.investigations;
    } else if (this.currentTab && this.currentTab.investigations && this.currentTab.investigations.length > 0) {
      investigations = this.currentTab.investigations;
    }
    return investigations.map((item: any) => item.investigation_name);
  }

  getAdvicesList(): string[] {
    let advices = null;
    if (this.printPrescriptionObject && this.printPrescriptionObject.advices && this.printPrescriptionObject.advices.advices && this.printPrescriptionObject.advices.advices.length > 0) {
      advices = this.printPrescriptionObject.advices.advices;
    } else if (this.currentTab && this.currentTab.advices && this.currentTab.advices.advices && this.currentTab.advices.advices.length > 0) {
      advices = this.currentTab.advices.advices;
    }
    return advices || [];
  }

  getNextVisitDate(): string {
    let nextVisit = '';
    if (this.printPrescriptionObject && this.printPrescriptionObject.advices && this.printPrescriptionObject.advices.nextVisit) {
      nextVisit = this.printPrescriptionObject.advices.nextVisit;
    } else if (this.currentTab && this.currentTab.advices && this.currentTab.advices.nextVisit) {
      nextVisit = this.currentTab.advices.nextVisit;
    }
    return nextVisit;
  }
}
